import { BankNames } from '@/constants';

export const FILE_NAMES = {
  grnAltyn: 'Гарантийное письмо',
  grnBcc: 'Гарантийное письмо',
  guaranteeHalyk: 'Гарантийное письмо',
  guaranteeShinhan: 'Гарантийное письмо',
  guaranteeSolva: 'Гарантийное письмо',
  BerekeGrn: 'Гарантийное письмо',
  spouseConsent: 'Согласие супруга(и) / Отсутствие супруга(и)',
  spouse_consent: 'Согласие супруга(и) / Отсутствие супруга(и)',
  techPassport: 'Фото тех. паспорта',
  tech_passport: 'Фото тех. паспорта'
};

export const banksToShowVehicleInfo = [
  BankNames.forte,
  BankNames.bereke,
  BankNames.euBank,
  BankNames.euBankV2,
  BankNames.ffb
];
